// @flow
import type { Note } from './types';

export const notesByAccount = (
  notes: Array<Note> = [],
): { [accountNo: string]: Note } =>
  notes.reduce((byAccount, note) => {
    byAccount[note.accountNo] = note;
    return byAccount;
  }, {});

/** Green when favorable, red when not, plain when on budget. */
export const varianceColor = (favorable: ?boolean): string => {
  if (favorable === true) {
    return 'success.main';
  }
  if (favorable === false) {
    return 'error.main';
  }
  return 'text.primary';
};

/** Up when actual is above budget, down when below. */
export const varianceArrow = (variance: number): string => {
  if (variance > 0) {
    return '▲';
  }
  if (variance < 0) {
    return '▼';
  }
  return '';
};

/** A percent with one decimal, or a dash when the budget is zero. */
export const formatPercent = (intl: Object, percent: ?number): string =>
  percent === null || percent === undefined
    ? '—'
    : intl.formatNumber(percent / 100, {
        style: 'percent',
        minimumFractionDigits: 1,
        maximumFractionDigits: 1,
      });

export const formatMoney = (intl: Object, value: number): string =>
  intl.formatNumber(value, { style: 'currency', currency: 'USD' });

/** Error text from a rejected API call, which is a string or { networkError }. */
export const errorText = (error: mixed): ?string => {
  if (typeof error === 'string') {
    return error;
  }
  if (error && typeof error === 'object') {
    const { networkError, message } = (error: Object);
    return networkError ?? message ?? null;
  }
  return null;
};
